import { useResolvedAccessLevel } from '../../components/PermissionsContainer';

/**
 * Component id for leg editing — the gate on the /pro legs grid.
 *
 * Appointment numbers resolve through canEditOrigin / canEditDestination, whose
 * permission floor is this component. Anything reaching a leg field from elsewhere
 * has to respect it, or the other surface becomes the way around it.
 */
export const LEG_EDITING_COMPONENT_ID = 'leg-editing';

/** Whether the current user may edit leg fields. */
export const useCanEditLegFields = (): boolean =>
  useResolvedAccessLevel(LEG_EDITING_COMPONENT_ID) >= 2;
